import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderPauseResumeResponseImplEncoder } from "../../encoder/OrderPauseResumeResponseImplEncoder";

import * as CubiqTS from "../../index";
import { OrderPauseResumeResponse } from "../OrderPauseResumeResponse";

export class OrderPauseResumeResponseImpl
  extends ConcreteEncodable
  implements OrderPauseResumeResponse
{
  public static enType: string = "com.bcdfx.model.event.OrderPauseResumeResponseImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public state: CubiqTS.PauseState;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=4*/
  public alreadyInState: boolean;
  /*FID=5*/
  public error: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderPauseResumeResponseImplEncoder.Instance;
    this.setEncodableType(OrderPauseResumeResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderPauseResumeResponseImpl[" +
      "orderId=" +
      this.orderId +
      "state=" +
      this.state +
      "errors=" +
      this.errors +
      "alreadyInState=" +
      this.alreadyInState +
      "error=" +
      this.error +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
